import React from "react";
import { NavLink } from "react-router-dom";
import { ROUTES } from "../../../routes";
import styles from "./Footer.module.scss";

const Footer = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className={styles.footer}>
            <div className={styles.footer_links}>
                <a
                    href="https://legal.raincards.xyz/legal/privacy-policy"
                    className={styles.link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Notice
                </a>
                <NavLink
                    to={ROUTES.CARD_TERMS_US}
                    className={styles.link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Card Terms US
                </NavLink>
                <NavLink
                    to={ROUTES.CARD_TERMS_INTERNATIONAL}
                    className={styles.link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Card Terms International
                </NavLink>
                <a
                    href="https://legal.raincards.xyz/legal/prohibitions"
                    className={styles.link}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Prohibitions
                </a>
                {/* <NavLink to={ROUTES.CARD_DISCLOSURES_AGREEMENT} className={styles.link}>
                    Card Terms
                </NavLink> */}
            </div>
            <div className={styles.footer_copyright}>
                &copy; {currentYear} STBL  All rights reserved.
            </div>
        </footer>
    );
};

export default Footer;
